var map = {
	"./arrow-down.svg": 651,
	"./arrow-left.svg": 252,
	"./arrow-right.svg": 5395,
	"./arrow-up.svg": 2276,
	"./check.svg": 789,
	"./chevron-down.svg": 7121,
	"./chevron-up.svg": 4110,
	"./cooking-time.svg": 8229,
	"./copy.svg": 2260,
	"./difficulty-level.svg": 5525,
	"./facebook.svg": 3995,
	"./instagram.svg": 1497,
	"./linkedin.svg": 7197,
	"./mail.svg": 5450,
	"./menu-close.svg": 1441,
	"./menu.svg": 2358,
	"./minus-sign.svg": 9073,
	"./phone.svg": 9885,
	"./play-filled.svg": 594,
	"./play.svg": 8769,
	"./plus-sign.svg": 1027,
	"./rating.svg": 2480,
	"./search.svg": 4771,
	"./share.svg": 1848,
	"./star-empty.svg": 7999,
	"./star-full.svg": 9875,
	"./twitter.svg": 7124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;